import React, { useState } from "react";
import "./SysGuard.scss";
import TimeSelector from "./Dashboard/Components/TimeSelector";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Content_Paths } from "./sysGuardConstants";
import SysGuardIncognito from "./SysGuardIncognito";
import SysGuardAlertViewSwitch from "./SysGuardAlertViewSwitch";
import DataSourceSelector from "./DataSourceSelector";
import OnBoardForm from "./OnBoarding/OnBoardForm";
import { Button } from "@material-ui/core";

function SysGuardHeader({ source }) {
  const location = useLocation();
  const history = useHistory();
  const [isEditMode, setIsEditMode] = useState(false);
  const [openOnBoardingForm, setOpenOnBoardingForm] = useState(false);

  const renderSYSGuardHeader = () => {
    return (
      <div className="sys-guard-header-container">
        <div className="riskGovernanceHeaderContainer">
          <div>
            <h2
              className={
                Content_Paths.includes(location.pathname)
                  ? "sysGuardHeaderTitle content"
                  : "sysGuardHeaderTitle"
              }
              onClick={() =>
                Content_Paths.includes(location.pathname) &&
                history.push("/mdr/sysguard")
              }
            >
              SysGuard Overview
            </h2>
          </div>
        </div>
        <div className="menu-time-container">
          <TimeSelector />
          <DataSourceSelector 
            setIsEditMode={setIsEditMode}
            setOpenOnBoardingForm={setOpenOnBoardingForm}
          />
          <Button
            className="createSysGuardButton"
            onClick={() => {
              setIsEditMode(false);
              setOpenOnBoardingForm(true);
            }}
          >
            Add
          </Button>
        </div>
        <div>
          <SysGuardAlertViewSwitch />
        </div>
        <SysGuardIncognito loc="overView" />
      </div>
    );
  };
  return (
    <div>
      {renderSYSGuardHeader()}
      <OnBoardForm
        openForm={openOnBoardingForm}
        setOpenForm={setOpenOnBoardingForm}
        source={source}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
      />
    </div>
  );
}

export default SysGuardHeader;
